import { useRunReportQuery } from "../../../api/network/reportApiServices";
import { REPORT_FILTER_BY_OPTION_VALUES } from "../../../constants/constants";
import { jsTimeToDBTime } from "../../../utils/dateTime";
import { useOverviewContext } from "../context/overview.context";

export const useGroupsAndAssetsUtils = (
  type: string,
  reportId = 78,
  data: string[],
  page = 1,
  page_size = 10,
  ordering?: string,
  ...additionalParams: Record<string, any>[]
) => {
  const { allTimeFilters, timeFilter, allAssetsSelected, allGroupsSelected } =
    useOverviewContext();

  const getTimeRange = (timeFilter: any) => {
    const filter = allTimeFilters.find((filter) => filter.slug === timeFilter);
    if (!filter)
      return {
        start_time: undefined,
        end_time: undefined,
        ds_time_range: undefined,
      };

    const [start, end] = filter.timeRange || [];
    return {
      start_time: start ? start : undefined,
      end_time: end ? end : undefined,
      ds_time_range: filter.value,
    };
  };

  const payload = {
    id: reportId.toString(),
    page: page,
    page_size: page_size,
    ...(ordering && { ordering: ordering }),
    ...(type === REPORT_FILTER_BY_OPTION_VALUES.GROUP
      ? {
          device_groups:
            !allGroupsSelected && !!data && data.length > 0
              ? data.join(",")
              : [],
        }
      : {}),
    ...(type === REPORT_FILTER_BY_OPTION_VALUES.ASSET
      ? {
          device_id:
            !allAssetsSelected && !!data && data.length > 0
              ? data.join(",")
              : [],
        }
      : {}),
    ...getTimeRange(timeFilter),
    ...additionalParams.reduce((acc, param) => ({ ...acc, ...param }), {}), // Spread additional parameters into the payload
  };

  const {
    data: reportData,
    isFetching,
    isError,
    error: reportError,
    isUninitialized,
  } = useRunReportQuery(payload, {
    skip: false,
    // refetch below ensure that the widgets update after any chage
    // (esp. safety events widget after scorecard weight factors under account admin are updated)
    refetchOnMountOrArgChange: true,
  });
  return { reportData, isFetching, isError, reportError, isUninitialized };
};
